var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4987 1.33301C4.75203 1.33301 3.33203 2.75301 3.33203 4.49967C3.33203 6.21301 4.67203 7.59967 6.4187 7.65967C6.47203 7.65301 6.52537 7.65301 6.56537 7.65967C6.5787 7.65967 6.58536 7.65967 6.5987 7.65967C6.60536 7.65967 6.60537 7.65967 6.61203 7.65967C8.3187 7.59967 9.6587 6.21301 9.66537 4.49967C9.66537 2.75301 8.24537 1.33301 6.4987 1.33301Z",
    fill: "#121212",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88859 9.43293C8.02859 8.19293 4.99526 8.19293 3.12193 9.43293C2.27526 9.9996 1.80859 10.7663 1.80859 11.5863C1.80859 12.4063 2.27526 13.1663 3.11526 13.7263C4.04859 14.3529 5.27526 14.6663 6.50193 14.6663C7.72859 14.6663 8.95526 14.3529 9.88859 13.7263C10.7286 13.1596 11.1953 12.3996 11.1953 11.5729C11.1886 10.7529 10.7286 9.99293 9.88859 9.43293Z",
    fill: "#121212",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8263 4.89307C13.9329 6.18641 13.0129 7.31974 11.7396 7.47307C11.7329 7.47307 11.7329 7.47307 11.7263 7.47307H11.7062C11.6662 7.47307 11.6262 7.47307 11.5929 7.48641C10.9462 7.51974 10.3529 7.31307 9.90625 6.93307C10.5929 6.31974 10.9863 5.39974 10.9063 4.39974C10.8596 3.85974 10.6729 3.36641 10.3929 2.94641C10.6463 2.81974 10.9396 2.73974 11.2396 2.71307C12.5463 2.59974 13.7129 3.57307 13.8263 4.89307Z",
    fill: "#121212",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1615 11.0599C15.1081 11.7066 14.6948 12.2666 14.0015 12.6466C13.3348 13.0133 12.4948 13.1866 11.6615 13.1666C12.1415 12.7333 12.4215 12.1933 12.4748 11.6199C12.5415 10.7933 12.1481 9.99994 11.3615 9.36661C10.9148 9.01327 10.3948 8.73327 9.82812 8.52661C11.3015 8.09994 13.1548 8.38661 14.2948 9.30661C14.9081 9.79994 15.2215 10.4199 15.1615 11.0599Z",
    fill: "#121212",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/Followers.4ecade6b2ef5f5c0a7ec94e731139b5c.svg";
export { ForwardRef as ReactComponent };